import { Dispatch } from "redux";
import { ActionType } from "../actions/ActionTypes";
import axios from "axios";
import { toast } from "react-toastify";
import { GetUserProfile } from "./UserAction";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const generateImage = (payload: any) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GENERATE_IMAGE_INIT });
      const url = `${BASE_URL}/image/create`;
      const response = await axios.post(url, payload);
      dispatch({
        type: ActionType.GENERATE_IMAGE_SUCCESS,
        payload: response.data.image,
      });
      toast.success('Image creation started');
      dispatch(GetUserProfile(localStorage.getItem("uid")!));
    } catch (error: any) {
      dispatch({
        type: ActionType.GENERATE_IMAGE_FAIL,
        payload: error.response?.data?.message || "Error generating image.",
      });
      toast.error(error.response?.data?.message || "Error generating image.");
    }
  };
};

export const deleteImage = (imageId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.DELETE_IMAGE_INIT });
      const url = `${BASE_URL}/image/delete/${imageId}`;
      const response = await axios.delete(url);

      toast.success("Image deleted successfully!", { autoClose: 3000 });
      dispatch({
        type: ActionType.DELETE_IMAGE_SUCCESS,
        payload: response.data,
      });
      dispatch(getAllImagesByUser(localStorage.getItem("uid")!));
    } catch (error: any) {
      toast.error(error.response?.data?.message || "Error deleting image.", {
        autoClose: 3000,
      });

      dispatch({
        type: ActionType.DELETE_IMAGE_FAIL,
        payload: error.response?.data?.message || "Error deleting image.",
      });
    }
  };
};

export const getSingleImage = (imageId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_SINGLE_IMAGE_INIT });
      const url = `${BASE_URL}/image/${imageId}`;
      const response = await axios.get(url);
      dispatch({
        type: ActionType.GET_SINGLE_IMAGE_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: ActionType.GET_SINGLE_IMAGE_FAIL,
        payload: error.response?.data?.message || "Error fetching image.",
      });
    }
  };
};

export const getAllImagesByUser = (userId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.GET_ALL_IMAGE_INIT });
      const url = `${BASE_URL}/image/user/${userId}`;
      const response = await axios.get(url);
      dispatch({
        type: ActionType.GET_ALL_IMAGE_SUCCESS,
        payload: response.data,
      });
    } catch (error: any) {
      dispatch({
        type: ActionType.GET_ALL_IMAGE_FAIL,
        payload: error.response?.data?.message || "Error fetching user images.",
      });
    }
  };
};

export const EditImageCaption = (imageId: any, newCaption: any) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.EDIT_IMAGE_CAPTION_INIT });
      const payload = {
        imageId: imageId,
        newCaption: newCaption,
      };
      const url = `${BASE_URL}/image/edit-caption`;
      const response = await axios.post(url, payload);
      dispatch({
        type: ActionType.EDIT_IMAGE_CAPTION_SUCCESS,
        payload: { imageId, newCaption },
      });
    } catch (error: any) {
      dispatch({
        type: ActionType.EDIT_IMAGE_CAPTION_FAIL,
        payload: error.response?.data?.message || "Error generating image.",
      });
      toast.error(error.response?.data?.message || "Error generating image.");
    }
  };
};

export const cancelImage = (imageId: string) => {
  return async (dispatch: Dispatch<any>) => {
    try {
      dispatch({ type: ActionType.CANCEL_IMAGE_INIT });
      const url = `${BASE_URL}/image/cancel/${imageId}`;
      const response = await axios.delete(url);
      dispatch({
        type: ActionType.CANCEL_IMAGE_SUCCESS,
        payload: response.data,
      });
      toast.success("Image generation cancelled");
    } catch (error: any) {
      dispatch({
        type: ActionType.CANCEL_IMAGE_FAIL,
        payload: "Error cancelling image.",
      });
      toast.error("Failed to create image. Please try again later.");
    }
  };
};
